export default "__VITE_ASSET__xXcCkcYA__"